const userSelector = (state: any) => state.user;
const roleSelector = (state: any) => state.role;
const orgSelector = (state: any) => state.org;
const hotelSelector = (state: any) => state.hotel;
const globalConfigSelector = (state: any) => state.globalConfig;
const siteSelector = (state: any) => state.site;

export { orgSelector, roleSelector, userSelector, hotelSelector, globalConfigSelector, siteSelector };
